import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {PartnerDgSearchResults} from "../models/datagrid-search-results/partner-dg-search.results";
import {PartnerService} from "../providers/partner.service";
import {environment} from "../../environments/environment";

@Injectable()
export class PartnersResolve implements Resolve<PartnerDgSearchResults> {
  constructor(private partnerService: PartnerService, private appStateService: AppStateService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<PartnerDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.partnerService.getResults( environment.DEFAULT_RESULTS_LIMIT,0,'ASC','created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
